module.exports = __webpack_public_path__ + "media/rpg-gameplay.7f12f2ee.mp4";